import { render } from "./AAACProfile.vue?vue&type=template&id=fd406960&scoped=true"
import script from "./AAACProfile.vue?vue&type=script&lang=js"
export * from "./AAACProfile.vue?vue&type=script&lang=js"

import "./AAACProfile.vue?vue&type=style&index=0&id=fd406960&scoped=true&lang=css"

import exportComponent from "/var/www/admin_web_aaac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd406960"]])

export default __exports__